import React from 'react';
import { useSelector } from 'react-redux';
import StepsContent from '../../components/stepsContent';
import ActionBar from '../../components/actionBar';
import ProgressBar from '../../components/progressBar';
import steps from '../../survey/steps';
import store from '../../store';
import MenuButton from '../../components/menuButton';
import HeaderV2 from '../../components/headerV2';
import SmartHeader from '../../components/smartHeader';
import getParameterFromURL from '../../utils/scripts/getParameterFromURL';
import s from './index.module.scss';
import logo from './img/logo2.png';
// import { customV1 } from '../../survey/configs';

const START_PAGES = new Set([
  'customV1_startPage',
  'customV2_startPage',
  'customV2_policyPage',
  'customV2_policyPageV2',
  'customV2_policyPageV3',
  'customV2_policyPageV4',
  'customV2_policyPageV5',
  'customV2_videoPolicyPage',
  'customV2_start_page_video',
  'customV2_startPageV2',
  'customV2_start_page_video_v2',
  'customV2_startPageV3',
  'customV2_startPageV4',
  'customV2_startPageV5',
  'customV2_startPageV6',
  'customV2_startPageV7',
  'customV2_startPageV8',
  'customV2_startPageV11',
  'customV2_startPageV12',
  'customV2_startPageV13',
  'customV2_startPageV17',
  'customV2_startPageV18',
  'customV2_startPageV19',
  'customV2_startPageV20',
  'customV2_startPageV21',
  'customV2_startPageV22',
  'customV2_startPageV23',
  'customV2_startPageV24',
  'customV2_startPageV25',
  'customV2_startPageV26',
  'customV2_startPageV27',
  'customV2_startPageV28',
  'customV2_startPageV29',
  'customV2_startPageV30',
  'customV2_startPageV31',
]);

function HeaderButton({ showMenuButton }) {
  const { currentStep } = store.getState().steps;
  const hideElement = currentStep === 'customV1_email';
  const hideClass = hideElement ? s.hideClass : '';

  function goBack() {
    steps.navigate.back();
    steps.userMovedToPreviousStepByClick();
  }

  if (showMenuButton) {
    return (
      <div className={`${s.menuButtonWrapper}`}>
        <MenuButton />
      </div>
    );
  }

  return (
    <button data-prevent-from-blur onClick={goBack} type="button" className={`${s.goBackButton} ${hideClass}`}>
      <div data-prevent-from-blur className={s.goBackButtonContent} />
    </button>
  );
}

function Steps() {
  const showActionBar = useSelector((state) => state.steps.showActionBar);
  const currentStepCompleted = useSelector((state) => state.steps.currentStepCompleted);
  const showMenuButton = useSelector((state) => state.steps.currentStepIndex) === 0;
  const showStartSurveyScreen = useSelector((state) => state.steps.showStartSurveyScreen);
  const menuOpenedClass = useSelector((state) => state.global.menuOpened) ? s.menuOpened : '';
  const transparentBgClass = useSelector((state) => state.global.isStatusBarTransparent) ? s.transparentBg : '';
  const { currentStepIndex } = store.getState().steps;
  const config = useSelector((state) => state.steps.config);
  const showStartSurveyScreenStyle = showStartSurveyScreen ? { visibility: 'hidden' } : {};
  const disableScroll = (currentStepIndex < 4 && config === 'short') ? s.disableScroll : '';
  const customV1Version = getParameterFromURL('config') === 'customV1';
  const customV2Version = getParameterFromURL('config') !== 'customV1';
  const { currentStep } = store.getState().steps;
  const customV1Loader = currentStep === 'customV1_loader';
  const customV1Email = currentStep === 'customV1_email';
  const startPage = START_PAGES.has(currentStep);

  let headerContent = null;
  if (customV2Version) {
    headerContent = (config === 'customV45' || config === 'customV48' || config === 'customV51' || config === 'customV52') ? <SmartHeader /> : <HeaderV2 />;
  }

  return (
    <div className={s.page}>
      
      <div className={`${s.contentWrapper} ${disableScroll} stepContentWrapper`} style={showStartSurveyScreenStyle}>
        {customV2Version ? (
          headerContent
        ) : (
          <div className={`${s.header} ${transparentBgClass} ${menuOpenedClass}`}>
            <div className="debug" />
            { (!customV1Loader && !customV1Email && !startPage) && (
              <div className={s.topContent}>
                <HeaderButton showMenuButton={showMenuButton} />
                <ProgressBar />
                <img src={logo} className={s.logo} alt="Everydoggy" />
              </div>
            )}
          </div>
        )}
        <StepsContent />
        <ActionBar show={showActionBar} currentStepCompleted={currentStepCompleted} withShadow={customV1Version} />
      </div>
    </div>
  );
}

export default Steps;
